/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });


/*************************************************/
/* Partials                                      */
/*************************************************/
import { lottieAnimation } from "./partials/lottieAnimations.js";
import { intersectionObservation } from "./partials/intersectionObservation.js";
import  Recaptcha  from './partials/recaptcha';
import { header } from "./partials/header.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { accordion } from "./partials/accordion.js";
import { countdown } from "./partials/countdown.js";
import { slider } from "./partials/slider.js";
import { video } from "./partials/video.js";
import { cookies } from "./partials/cookies.js";
import { NewsletterSignup } from "./partials/newsletterSignup.js";
import { mmenu } from "./partials/mmenu.js";
import { basmResale } from "./partials/basmResale.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    Recaptcha.Init();

    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    //Handle scroll to submitted form element
    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    if(formSubmittedElement){
        window.scrollTo(0,formSubmittedElement.closest('.form-item').offsetTop);
    }

    //Fire dataLayer event for forms submission
    const formSubmitMessage = document.querySelector('[class^="umbraco-forms-submitmessage"]');
    if(formSubmitMessage){
        window.dataLayer.push({
            'event': 'formSubmission',
            'formType':formSubmitMessage.dataset.formName
        });
    }

    //Add click listener to skip link
    document.querySelector('#skipLink').addEventListener('click',e => {
        document.querySelector('#mainContent').focus();
    });
    
    lottieAnimation();
    intersectionObservation();
    header(body);
    mmenu();
    search();
    searchbar(body);
    slider();
    countdown();
    accordion();
    video();
    cookies();
    NewsletterSignup();
    basmResale();
});
